<template>
  <div class="editable-select editing-cell" v-if="isEditing">

    <v-select
      class="select-box"
      v-model="input"
      :options="selectOptions"
      label="name"
      :reduce="country => country.id"
      placeholder="選択してください"
      :getOptionKey="(option) => option.id"
      :clearable="false"
      :searchable="false"
    />

  </div>
  <div v-else class="editable-select">
    {{selectedValue}}
  </div>
</template>

<script>

import vSelect from 'vue-select'

export default {
  components: {
    vSelect,
  },
  props: {
    value: { type: String },
    selectOptions: { type: Array },
    isEditing: { type: Boolean },
  },
  data() {
    return {
      input: this.value,
    }
  },
  computed: {
    selectedValue() {
      let index = this.selectOptions.findIndex(element => element.id == this.value)
      return this.selectOptions[index].name
    }
  },
  watch: {
    input: {
      handler: function(value) {
        this.$emit("updateValue", value)
      },
      immediate: true,
    },
    isEditing() {
      this.input = this.value
    }
  },
}
</script>

<style lang="scss">
.editing-cell {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.editable-select {
  min-width: 120px;
  .select-box {
    width: 100%;
    height: 37px;
  }
  .vs__dropdown-toggle {
    height: 100% !important;
    background: white;
  }
  .vs__selected-options {
    align-items: center;
  }
}
</style>
